/** Outline + label color only (no fill); keys match backend LeadCategory.key */
export const LEAD_CATEGORY_OUTLINE_COLORS = {
  cold: "#546E7A",
  warm: "#EF6C00",
  mql: "#7B1FA2",
  sql: "#2E7D32",
  pql: "#00838F",
  svl: "#3949AB",
  referral: "#AD1457",
  inbound: "#1565C0",
  outbound: "#6D4C41",
};

export function getLeadCategoryOutlineColor(lead) {
  const key = (lead?.category_key || "").toLowerCase().trim();
  if (key && LEAD_CATEGORY_OUTLINE_COLORS[key]) {
    return LEAD_CATEGORY_OUTLINE_COLORS[key];
  }
  return "#757575";
}

export function leadCategoryChipSx(color) {
  return {
    bgcolor: "transparent",
    borderColor: color,
    color,
    fontWeight: 600,
    "& .MuiChip-label": { px: 1 },
    "&:hover": {
      bgcolor: "transparent",
      borderColor: color,
      color,
    },
  };
}
